import React from "react";
import Link from "next/link";
const FirstSection = ({ scrollhandleClick }) => {
    return (
        <>
            <h2>You Already Hold The Keys To Your Greatest Potential for Health, Happiness, and Longevity…</h2>



            <h2 className="now-you-heading">Now You Just Have To Open The Lock.</h2>
            <div className="first-section-main">
                <div className="first-section-left-content">
                    <p>Optimal health starts with optimal nutrition… only there is no “one-size-fits-all” solution.</p>

                    <p>Your body is one-of-a-kind, so “optimal nutrition” for you must be personalized to your unique needs…</p>

                    <p>…and that’s where our groundbreaking <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> Supplement comes into play. </p>

                    <p>Using your existing DNA analysis, we apply cutting-edge innovation to create a <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> formula specifically for YOU, loaded with high-quality, bioactive ingredients tailored exactly to your nutritional
                        needs.</p>
                    <p>Billions of formulations are possible in our <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link>  – <b><a className="only-one-anchor"><u>Only ONE is made for YOU!</u></a></b></p>
                </div>
                {/* a href="#" className="only-one-anchor">Only one is made for you!</a> */}
                <div className="first-section-right-image">
                    <img src="/images/first-section-right-image.jpg" />
                </div>
            </div>
        </>
    )
}

export default FirstSection;